export default "__VITE_ASSET__B1yd2log__"